module.exports = __webpack_public_path__ + "WoodBg-210a918df33442b5af619436b27af677.png";